import React from 'react';
import AdvisoriesSummaryProps from '../interfaces/AdvisoriesSummaryProps';

const HeaderInspectionSummary: React.FC<AdvisoriesSummaryProps> = ({ report }) => {
    const headers = report as unknown as Record<string, string>;
    const headerNames = Object.keys(headers);

    if (headerNames.length === 0) {
        return <p>Aucun problème de sécurité détecté</p>;
    }

    return <ul>
        {headerNames.map((header: string) => (
            <li key={header}>
                <strong>{header}</strong> : {headers[header]}
            </li>
        ))}
    </ul>
}

export default HeaderInspectionSummary;
